import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Utilisation rate' },
  graphDotName: { defaultMessage: 'Utilisation rate' },
});
